// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
        totalSupply = totalSupply -1;
      let account = await store
        .getState()
        .blockchain.account;
      let minted = await store
        .getState()
        .blockchain.smartContract.methods.claimedGift(account)
        .call();
      let psEnable = await store
        .getState()
        .blockchain.smartContract.methods.publicSaleEnabled()
        .call();
        let psMinted = await store
        .getState()
        .blockchain.smartContract.methods.publicSaleMinted(account)
        .call();
        

      dispatch(
        fetchDataSuccess({
          totalSupply,
          minted,
          psEnable,
          psMinted,
          // cost,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
